import { Buffer } from "buffer";
export const whitelistParams = [
  "fbclid",
  "gclid",
  "dclid",
  "gclsrc",
  "MSCLKID",
  "utm_content",
  "utm_term",
  "utm_campaign",
  "utm_medium",
  "utm_source",
  "_ga",
  "mc_cid",
  "mc_eid",
  "_bta_tid",
  "_bta_c",
  "trk_contact",
  "trk_msg",
  "trk_module",
  "trk_sid",
  "gdfms",
  "gdftrk",
  "gdffi",
  "_ke",
  "redirect_log_mongo_id",
  "redirect_mongo_id",
  "sb_referer_host",
  "mkwid",
  "pcrid",
  "ef_id",
  "s_kwcid",
  "msclkid",
  "dm_i",
  "epik",
  "campaignid",
  "adplacement",
  "jumpid",
  "ecid",
  "sku",
  "skus",
  "pdpFlow",
  "hpChannel",
  "hpChannelGroup",
];

export const getQueryParamsFiltered = (
  queryParams: URLSearchParams
): { whiteListedParams: string[]; blackListedParams: string[] } => {
  const whiteListedParams: string[] = [];
  const blackListedParams: string[] = [];

  queryParams.forEach((value, key) =>
    whitelistParams.includes(key)
      ? whiteListedParams.push(`${key}=${value}`)
      : blackListedParams.push(`${key}=${"_redacted_"}`)
  );
  return { whiteListedParams, blackListedParams };
};

export const decodeToken = (token: string) => {
  return JSON.parse(Buffer.from(token.split(".")[1], "base64").toString());
};
